import React from 'react';
import cc from 'classcat';

import {Button, ContactButtons} from '../../components';
import { useSiteQuery, useStore } from '../../hooks';
import { renderPageContent } from '../../lib/ContentRenderer';
import ErrorPage from '../_error';
import NotFoundPage from '../404';

import FaxIcon from '../../images/icons/fax.svg';
import PhoneIcon from '../../images/icons/phone-orange.svg';
import FeedbackIcon from '../../images/icons/feedback-orange.svg';
import PinIcon from '../../images/icons/pin.svg';
import PostalIcon from '../../images/icons/postal.svg';

import query from './index.graphql';

import styles from './index.module.scss';

const ContactUs = () => {
  const [{ data, error }] = useSiteQuery<ContactUsQuery>({ query });
  const { phone } = useStore('globals');

  if (error) {
    return <ErrorPage statusCode={500} err={error} />;
  }

  const entry = data?.entry;

  if (entry) {
    return (
      <div className={styles.contact}>
        <div className="sectionWrapper">
          <div
              className={[
                entry.backgroundImage?.[0]?.url ? styles.heroBackground : '',
                entry.backgroundImage?.[0]?.url || entry.headingTextTertiary || entry.linkToPanelId ? styles.heroBanner : '',
                'pageBanner'
              ].filter(Boolean).join(' ')}
              {
                ...(entry.backgroundImage?.[0]?.url && { style: { backgroundImage: `url(${entry.backgroundImage[0].url})` } })
              }
          >
            <div className={styles.container + ' container'}>
              <h1>{entry.headingTextPrimary ? entry.headingTextPrimary : 'We’d love to hear from you' }</h1>
              <p>{entry.headingTextSecondary ? entry.headingTextSecondary : 'We’re here to help and answer any questions you might have.' }</p>
              <ContactButtons />
              {entry.headingTextTertiary && (
                  <p>{entry.headingTextTertiary}</p>
              )}
              {entry.linkToPanelId && (
                <Button large href={'#' + entry.linkToPanelId} type="orangeBorder" className={'newStyleButtonOverrideSolid xl-mr-auto'}>
                  <FeedbackIcon />
                  <strong>Provide Feedback</strong>
                </Button>
              )}
            </div>
            <div className={styles.backgroundGradient}>
            </div>
          </div>
        </div>
        <div className="section section-white">
          <div className={cc(['container', styles.mainServiceContainer])}>
            <h2 className="center">{entry.headline!}</h2>
            <p className="center">{entry.description!}</p>
            <div className={styles.mainServices}>
              <div className={styles.mainService}>
                <PhoneIcon />
                <div>
                  <h4>Phone</h4>
                  <p>
                    <PhoneIcon />
                    {phone}
                  </p>
                </div>
              </div>
              <div className={styles.mainService}>
                <PinIcon />
                <div>
                  <h4>Address</h4>
                  <p>
                    <PinIcon />
                    {entry.address!.address}
                  </p>
                </div>
              </div>
              <div className={styles.mainService}>
                <PostalIcon />
                <div>
                  <h4>Postal address</h4>
                  <p>
                    <PostalIcon />
                    {entry.postalAddress!}
                  </p>
                </div>
              </div>
              <div className={styles.mainService}>
                <FaxIcon />
                <div>
                  <h4>Fax</h4>
                  <p>
                    <FaxIcon />
                    {entry.fax!}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {entry.contacts?.map(
          (item, idx) =>
            item && (
              <div key={item.uid!} className={cc(['section', { 'section-white': idx % 2 === 1 }])}>
                <div className="container">
                  <h2 className="center">{item.headline!}</h2>
                  <div dangerouslySetInnerHTML={{ __html: item.description! }} />
                  <div className={cc(['row', styles.centres])}>
                    {item.children?.map(
                      (centre) =>
                        centre && (
                          <div key={centre.uid!} className={cc(['col-md-6 col-lg-3', styles.centre])}>
                            <h4>{centre.title!}</h4>
                            <p>{centre.location!}</p>
                            {centre.phone! && (
                              <a href={`tel:${centre.phone!.replace(/[^\d\+]/g, '')}`}>
                                <PhoneIcon />
                                {centre.phone!}
                              </a>
                            )}
                          </div>
                        ),
                    )}
                  </div>
                </div>
              </div>
            ),
        )}
        {entry.pageContent?.map((row) => renderPageContent(row!, false, entry))}
      </div>
    );
  }

  return <NotFoundPage />;
};

export default ContactUs;
